import { createUseStyles } from "react-jss";
import Card from "../../Components/Card";
import SectionBlock from "../../Components/SectionBlock";
import { globe } from "../../Assets/Images";
import Button from "../../Components/Button";
import { Link, useNavigate } from "react-router";

const useStyles = createUseStyles({
  root: {
    width: 500,
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  logo: {
    width: 175,
    marginBottom: 30,
  },
  actions: {
    marginTop: 30,
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-around",
  },
});

const ThankYouForRegistering = () => {
  const classes = useStyles();
  const naviagte = useNavigate();
  return (
    <SectionBlock variant="white">
      <Card>
        <div className={classes.root}>
          <img alt="EMPD globe logo" src={globe} className={classes.logo} />
          <h2>Thank You For Registering!</h2>
          <p>
            Welcome and thank you for registering with the{" "}
            <b>Global EMPD Initiative</b>. If you would like to participate in
            our research activities, please click the link below to help.
          </p>
          <div className={classes.actions}>
            <Link to={"/"}>{"No, thank you"}</Link>
            <Button
              onClick={() => naviagte("/patient-portal-registration")}
              label="Yes, I'd like to participate"
            />
          </div>
        </div>
      </Card>
    </SectionBlock>
  );
};

export default ThankYouForRegistering;
